import { Card, CardHeader, IconButton, Snackbar, SnackbarContent } from '@material-ui/core';
import { green } from "@material-ui/core/colors";
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import clsx from 'clsx';
import { ImageDropzone } from 'components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Mastery } from 'services';
import { ModelsActions } from "store/actions";
import useErrorCatcher from "utils/useErrorCatcher";

const useStyles = makeStyles(theme => ({
  root: {},
  snackbar: {
    backgroundColor: green[400]
  },
  snackbarMessage: {
    display: "flex",
    alignItems: "center",
  },
}));
const MasteryIcon = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.mastery);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const runAsyncBlock = useErrorCatcher(error => setError(error && error.message));
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  const handleUpload = () => {
    if (!file) return;
    setLoading(true);

    runAsyncBlock(async () => {
      let response = await Mastery.image(model.id, file);
      dispatch(ModelsActions.update_model({ mastery: { ...model, main_image: response } }));
      setFile(null);
      setSnackOpen(true);
      setSnackbarMessage("Upload Success!");
    }).finally(() => setLoading(false));
  }
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Mastery Icon" />
      <ImageDropzone
        file={file}
        error={error}
        setFile={setFile}
        setError={setError}
        fileLoading={loading}
        image={model.main_image}
        handleUpload={handleUpload}
      />
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={snackOpen}
        autoHideDuration={3000}
        onClose={handleSnackClose}
      >
        <SnackbarContent
          className={classes.snackbar}
          message={<span className={classes.snackbarMessage}><CheckCircleIcon className={clsx(classes.icon, classes.iconVariant)} />{snackbarMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              className={classes.close}
              onClick={handleSnackClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </Card>
  );
};

MasteryIcon.propTypes = {
  className: PropTypes.string
};

export default MasteryIcon;
